/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
import $ from "jquery"
import {
    prefix,
    isResponsiveXS,
    isResponsiveMD,
} from "./globals";

const DATA_OPEN_KEY = 'open';
const DATA_INDEX = 'index';
const DATA_FULL_HEIGHT = 'full-height'
const DATA_MIN_HEIGHT = 'min-height'
const ANIM_SPEED = 300;

const isResponsiveSM = () => window.matchMedia("only screen and (max-width: 768px)").matches

class SimpleCollapse {
    constructor() {
        this.$simpleCollapse = $(`.${prefix}-simple-collapse`);

        if (!this.$simpleCollapse.length) return;

        this.$panels = this.$simpleCollapse.find('.collapse-content-container');
        this.$collapseItems = this.$simpleCollapse.find('.collapse-item');
        this.lastCollapseClose = undefined;

        this.initAllCollapseContainer();
        this.$collapseItems.on('click mouseover', (evt) => {
            this.showCollapseElement(evt);
        });
        this.$collapseItems.first().click();
    }

    showCollapseElement(evt) {
        const $this = $(evt.currentTarget),
            isMouseOver = evt.type === "mouseover",
            $collapseContentContainer = $this.find('.collapse-content-container'),
            isCollapseOpen = $collapseContentContainer.data(DATA_OPEN_KEY),
            index = $collapseContentContainer.data(DATA_INDEX);

        if ((isCollapseOpen && isMouseOver)
            || (this.lastCollapseClose === index && isMouseOver)) return;

        if (isCollapseOpen) {
            this.hideCollapse($collapseContentContainer);
            this.lastCollapseClose = index;

            return;
        }

        this.hideAll();
        this.showCollapse($collapseContentContainer);
    }

    initAllCollapseContainer() {
        this.$panels.each((key, item) => {
            const $collapseContentContainer = $(item);
            $collapseContentContainer.data(DATA_INDEX, key);

            this.addMinFullHeight($collapseContentContainer);
            if (key !== 0)
                this.hideCollapse($collapseContentContainer);
        });
    }

    hideAll() {
        this.$panels.each((key, item) => {
            this.hideCollapse($(item));
        });
    }

    addMinFullHeight($collapseContentContainer) {
        const height = $collapseContentContainer.height(),
            $p = $collapseContentContainer.find('p').first(),
            isXs = isResponsiveXS(),
            isSM = isResponsiveSM(),
            isMD = !isResponsiveMD(),
            rowsToShow = (isXs || isSM) ? 6 : 2,
            lineHeight = parseInt(
                $p.css('line-height').replace('px', ''), 10
            ),
            marginTop = parseInt(
                $p.css('margin-top').replace('px', ''), 10
            );
        let mini = (lineHeight * rowsToShow) + (marginTop - ((isXs) ? 2 : 10));

        if (!isMD && !isXs) {
            mini += 36;
        }

        if (isMD) {
            mini += 16;
        }

        $collapseContentContainer.data(DATA_FULL_HEIGHT, height + 'px');
        $collapseContentContainer.data(DATA_MIN_HEIGHT, mini + 'px');
        $collapseContentContainer.css('height', mini + 'px');
    }

    hideCollapse($collapseContentContainer) {
        const isOpen = $collapseContentContainer.data(DATA_OPEN_KEY);
        if (typeof isOpen !== "undefined" && isOpen === false) {
            return;
        }

        $collapseContentContainer.data(DATA_OPEN_KEY, false);
        $collapseContentContainer.animate({
            'height': $collapseContentContainer.data(DATA_MIN_HEIGHT)
        }, ANIM_SPEED)
            .parent('li')
            .addClass('collapse');
        if (isResponsiveSM())
            $collapseContentContainer.find('.image-container img').hide();
        else
            $collapseContentContainer.find('.image-container img').slideUp('fast');
    }

    showCollapse($collapseContentContainer) {
        if ($collapseContentContainer.data(DATA_OPEN_KEY)) {
            return;
        }

        $collapseContentContainer.data(DATA_OPEN_KEY, true);
        $collapseContentContainer.animate({
            height: $collapseContentContainer.data(DATA_FULL_HEIGHT),
            easing: 'linear'
        }, ANIM_SPEED)
            .parent('li')
            .removeClass('collapse');
        if (isResponsiveSM())
            $collapseContentContainer.find('.image-container img').show();
        else
            $collapseContentContainer.find('.image-container img').slideDown('fast');
    }

}

export default SimpleCollapse;